import { Skeleton, SkeletonItem } from "@fluentui/react-components";
import { Col, Row } from "react-grid-system";
import useStyleUtils from "../../utilities/styles";

const Placeholder = () => {
    const style = useStyleUtils();

    return (
        <Row>
            {
                Array.from({ length: 6 }).map((_, index) => (
                    <Col key={index} sm={12}>
                        <Row>
                            <Col key={index} xs={12} md={6} lg={4}>
                                <Skeleton>
                                    <SkeletonItem size={24}className={style.mb3} />
                                </Skeleton>
                            </Col>
                        </Row>
                    </Col>
                ))
            }
        </Row>
    );
};

export default Placeholder;